import { styled } from '../theme';

/**
 * Utils
 */

/**
 * Types
 */

type Props = {};

/**
 * Styled
 */

const Text = styled('span')<Props>(({ theme }) => ({
    fontSize: '1em',
}));

/**
 * Component
 * Only for extension by common components, DON NOT USE IN APPS!
 */

export default Text;
